// Runtime configuration sourced from Vite environment variables (VITE_*).
// Copy .env.example to .env.local and fill in real values for local development.

export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'https://localhost:5001',
  // URL of the standalone form builder app (drag-drop editor).
  formbuilderUrl: import.meta.env.VITE_FORMBUILDER_URL ?? 'http://localhost:5175',
  // Public renderer base URL, used to compose the respondent link (forms.<host>/f/{id}).
  publicFormsUrl: import.meta.env.VITE_PUBLIC_FORMS_URL ?? 'http://localhost:5174',
  entra: {
    tenantId: import.meta.env.VITE_ENTRA_TENANT_ID ?? 'common',
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID ?? '',
    // Scope the SPA requests when calling the Forms API (e.g. api://<api-client-id>/access_as_user).
    apiScope: import.meta.env.VITE_API_SCOPE ?? '',
  },
};
